"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProviderImpl = void 0;
var AirabbiUser_1 = require("../../airabbi/AirabbiUser");
var Future_1 = require("../../../utils/Future");
var UserCache_1 = require("./../../UserCache");
var CoreServiceHelper_1 = require("../airabbi/CoreServiceHelper");
var Utils_1 = require("../../../utils/Utils");
var UserProviderImpl = (function () {
    function UserProviderImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.lastActiveTime = 0;
        this.activeTime = 0;
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.timeText)(Date.now()), " UserServiceImpl#")], args, false));
            }
        };
        this.error = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).error.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.timeText)(Date.now()), " UserServiceImpl#")], args, false));
            }
        };
        this.info = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).info.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.timeText)(Date.now()), " UserServiceImpl#")], args, false));
            }
        };
        this.getAllUsers = function () {
            _this.log('UserServiceImpl#getAllUser');
            var future = new Future_1.Future(Future_1.futureFunc);
            _this.airabbiUser
                .getAllUser()
                .then(function (users) {
                return future.resolve(users);
            })
                .catch(function (err) { return future.reject(err); });
            return future.promise;
        };
        this.getMultiUsers = function (uidList) {
            uidList = uidList ? uidList.map(Utils_1.email2UID) : [];
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .queryData('Users', {
                uid: { $in: uidList }
            }, {}, {}, '')
                .then(function (res) { return (res && res.result ? res.result : []); })
                .catch(function (err) { return Promise.reject(err); });
        };
        this.getAllUsersByUnit = function () {
            var currentUser = (0, UserCache_1.loadUser)();
            _this.log('UserServiceImpl#getAllUsersByUnit');
            if (!currentUser.unit) {
                return Promise.reject('unit cannot be empty!');
            }
            var future = new Future_1.Future(Future_1.futureFunc);
            _this.airabbiUser
                .getAllUsersByUnit()
                .then(function (users) {
                return future.resolve(users);
            })
                .catch(function (err) { return future.reject(err); });
            return future.promise;
        };
        this.getAllUnits = function () {
            var future = new Future_1.Future(Future_1.futureFunc);
            _this.airabbiUser
                .getAllUnits()
                .then(function (units) {
                return future.resolve(units);
            })
                .catch(function (err) { return future.reject(err); });
            return future.promise;
        };
        this.getAllUsersByUnitPagination = function (skip, limit, searchType, sort, searchString, role, unit) {
            var currentUser = (0, UserCache_1.loadUser)();
            _this.log('UserServiceImpl#getAllUsersByUnitPagination');
            if (currentUser.role !== 'staff' && currentUser.uid !== 'developer-airabbi-com') {
                return Promise.reject('only staff user can use!');
            }
            var searchKeys = [];
            if (searchType === 'class') {
                searchKeys.push('moreInfo.studentClass');
            }
            else {
                searchKeys.push('displayName');
                searchKeys.push('email');
                searchKeys.push('unit');
            }
            var filter = {};
            if (role) {
                filter.role = role;
            }
            if (unit && unit !== 'all') {
                filter.unit = unit;
            }
            var future = new Future_1.Future(Future_1.futureFunc);
            searchString = searchString ? searchString : '';
            CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .queryPagination('Users', filter, sort, skip, limit, searchKeys, searchString)
                .then(function (response) {
                return future.resolve({
                    result: response && response.result ? response.result : [],
                    totalCount: response && response.totalCount ? response.totalCount : 0
                });
            })
                .catch(function (err) { return future.reject(err); });
            return future.promise;
        };
        this.getUsersByUnitPagination = function (skip, limit, searchType, sort, searchString, role) {
            var currentUser = (0, UserCache_1.loadUser)();
            _this.log('UserServiceImpl#getUsersByUnitPagination');
            if (!currentUser.unit) {
                return Promise.reject('unit cannot be empty!');
            }
            var searchKeys = [];
            if (searchType === 'class') {
                searchKeys.push('moreInfo.studentClass');
            }
            else {
                searchKeys.push('displayName');
                searchKeys.push('email');
            }
            var filter = {
                unit: currentUser.unit
            };
            if (role) {
                filter.role = role;
            }
            var future = new Future_1.Future(Future_1.futureFunc);
            searchString = searchString ? searchString : '';
            CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .queryPagination('Users', filter, sort, skip, limit, searchKeys, searchString)
                .then(function (response) {
                return future.resolve({
                    result: response && response.result ? response.result : [],
                    totalCount: response && response.totalCount ? response.totalCount : 0
                });
            })
                .catch(function (err) { return future.reject(err); });
            return future.promise;
        };
        this.createUser = function (user) { return _this.airabbiUser.createUser(user); };
        this.getStaffs = function () {
            var currentUser = (0, UserCache_1.loadUser)();
            _this.log('UserServiceImpl#getStaffs');
            if (!currentUser.unit) {
                return Promise.reject('unit cannot be empty!');
            }
            var future = new Future_1.Future(Future_1.futureFunc);
            _this.airabbiUser
                .getUsersByRole('staff')
                .then(function (users) {
                return future.resolve(users);
            })
                .catch(function (err) { return future.reject(err); });
            return future.promise;
        };
        this.getStudents = function () {
            var currentUser = (0, UserCache_1.loadUser)();
            _this.log('UserServiceImpl#getStudents');
            if (!currentUser.unit) {
                return Promise.reject('unit cannot be empty!');
            }
            var future = new Future_1.Future(Future_1.futureFunc);
            _this.airabbiUser
                .getUsersByRole('student')
                .then(function (users) {
                return future.resolve(users);
            })
                .catch(function (err) { return future.reject(err); });
            return future.promise;
        };
        this.getTeachers = function () {
            var currentUser = (0, UserCache_1.loadUser)();
            _this.log('UserServiceImpl#getTeachers');
            if (!currentUser.unit) {
                return Promise.reject('unit cannot be empty!');
            }
            var future = new Future_1.Future(Future_1.futureFunc);
            _this.airabbiUser
                .getUsersByRole('teacher')
                .then(function (users) {
                return future.resolve(users);
            })
                .catch(function (err) { return future.reject(err); });
            return future.promise;
        };
        this.removeUser = function (user) {
            return _this.airabbiUser.removeUser(user);
        };
        this.sendPasswordResetEmail = function (user) { return Promise.resolve(); };
        this.sendVerificationEmail = function (user) { return Promise.resolve(); };
        this.updateUser = function (user) { return _this.airabbiUser.updateUser(user); };
        this.removeOthers = function () {
        };
        this.onActive = function () {
            var timeout = 1000 * 60 * 10;
            if (Date.now() - _this.lastActiveTime < timeout) {
                _this.activeTime = Date.now();
                if (_this.timeoutInstanceSendActiveStatus) {
                    clearTimeout(_this.timeoutInstanceSendActiveStatus);
                    _this.timeoutInstanceSendActiveStatus = undefined;
                }
                _this.timeoutInstanceSendActiveStatus = setTimeout(function () {
                    if (_this.activeTime !== undefined) {
                        return _this.sendActiveEvent(_this.activeTime);
                    }
                    else {
                        return Promise.resolve();
                    }
                }, timeout);
                return Promise.resolve();
            }
            return _this.sendActiveEvent(Date.now());
        };
        this.sendActiveEvent = function (activeTime) {
            var user = (0, UserCache_1.loadUser)();
            if (!user) {
                return Promise.reject('!Unknown user!');
            }
            if (!user || !user.email || user.email === '') {
                return Promise.reject('!Unknown user!');
            }
            _this.lastActiveTime = Date.now();
            _this.activeTime = undefined;
            if (_this.timeoutInstanceSendActiveStatus) {
                clearTimeout(_this.timeoutInstanceSendActiveStatus);
                _this.timeoutInstanceSendActiveStatus = undefined;
            }
            _this.log('sendActiveEvent#');
            delete user.updated;
            var data = {
                updated: activeTime,
                updatedTime: (0, Utils_1.timeText)(activeTime),
                uid: user.uid,
                displayName: user.displayName,
                unit: user.unit,
                user: user
            };
            CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .createData('history', data)
                .then(function (result) { return _this.log('active time sent - ok'); })
                .catch(function (err) { return _this.log(err); });
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg).updateData('Users', { uid: user.uid }, { activeTime: Date.now() });
        };
        this.log('created#');
        this.airabbiUser = new AirabbiUser_1.AirabbiUser(cfg);
    }
    UserProviderImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        this.log('init# env:', env);
        this.airabbiUser.init(env);
        return Promise.resolve();
    };
    UserProviderImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    UserProviderImpl.prototype.queryUser = function (uid) {
        var future = new Future_1.Future(Future_1.futureFunc);
        CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryOne('Users', { uid: uid }, {})
            .then(function (res) {
            var user = res && res.result ? res.result : undefined;
            future.resolve(user);
        })
            .catch(function (err) { return future.resolve(undefined); });
        return future.promise;
    };
    UserProviderImpl.prototype.stopAllMonitor = function () {
    };
    UserProviderImpl.prototype.getSignUpUsers = function () {
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).queryData('signup-user', {}, {}, {}, '');
    };
    UserProviderImpl.prototype.querySignUpUser = function (email) {
        var body = { collection: 'signup-user', filter: { email: email } };
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).queryData(body.collection, body.filter, {}, {}, '');
    };
    UserProviderImpl.prototype.sendEmail4SignUp = function (user) {
        var _this = this;
        CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .sendEmail([
            'tengjie.huang@airabbi.com',
            'slime@airabbi.com',
            'jerry@airabbi.com',
            'bonnie@airabbi.com'
        ], "\u6709\u8001\u5E2B\u7533\u8ACB\u8A66\u7528CodingBar", "<div>\u7533\u8ACB\u4EBA:</div>" +
            "<div>\u59D3\u540D:".concat(user.name, "</div>") +
            "<div>Email:".concat(user.email, "</div><p/>") +
            "<div>\u96FB\u8A71:".concat(user.number, "</div><p/>") +
            "<div>\u8AB2\u7A0B:".concat(user.course, "</div><p/>") +
            "<div>\u5B78\u6821:".concat(user.school, "</div><p/>") +
            "<div>\u63A5\u53D7\u8A2A\u554F:".concat(user.acceptInterview === true ? '願意' : '不', "</div><p/>"))
            .then(function (result) {
            _this.log('sendEmail4SignUp# sendEmail# ok', result);
        })
            .catch(function (err) {
            _this.log('sendEmail4SignUp# sendEmail# error:', err);
        });
    };
    UserProviderImpl.prototype.sendEmail4SignUpTeacher = function (user) {
        var _this = this;
        CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .sendEmail([user.email], "\u611F\u8B1D\u60A8\u7533\u8ACB\u8A66\u7528 CodingBar \u7A0B\u5F0F\u6559\u80B2\u5B78\u7FD2\u7CFB\u7D71", "<div>\u89AA\u611B\u7684 ".concat(user.name, " \u60A8\u597D!<br></div>") +
            "<div><br>\u6211\u5011\u9810\u8A08\u5728\u5169\u500B\u5DE5\u4F5C\u65E5\u5167\u78BA\u8A8D\u60A8\u7684\u7533\u8ACB\u8CC7\u6599\uFF0C\u4E26\u70BA\u60A8\u958B\u901A\u8A66\u7528\u5E33\u865F\u3002</div>" +
            "<div>\u5982\u6709\u5176\u4ED6\u9700\u6C42\u6216\u554F\u984C\uFF0C\u8ACB\u900F\u904E\u4EE5\u4E0B\u65B9\u5F0F\uFF0C\u8207\u6211\u5011\u806F\u7D61\u3002</div>" +
            "<div><br>Line<br>@codingbar</div>" +
            "<div><br>\u96FB\u5B50\u90F5\u4EF6<br>service@codingbar.ai</div>" +
            "<div><br>\u516C\u53F8\u96FB\u8A71<br>(02)7717-9386</div>")
            .then(function (result) {
            _this.log('sendEmail4SignUpTeacher# sendEmail# ok', result);
        })
            .catch(function (err) {
            _this.log('sendEmail4SignUpTeacher# sendEmail# error:', err);
        });
    };
    UserProviderImpl.prototype.signUp = function (user) {
        this.log('signUp# user:', user);
        if (user && user.email && user.number) {
            this.sendEmail4SignUpTeacher(user);
            this.sendEmail4SignUp(user);
        }
        user.password = btoa(user.password ? user.password : '');
        this.log('signUp# user:', user);
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).createData('signup-user', user);
    };
    UserProviderImpl.prototype.getCodingbarDomainAccessUnitList = function () {
        var body = { collection: 'authorizedUnit', filter: { type: 'domain' } };
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData(body.collection, body.filter, {}, { _id: false }, '')
            .then(function (data) { return (data && data.status === 'success' ? data.result : []); });
    };
    UserProviderImpl.prototype.insertCodingbarDomainAccessUnitList = function (unit) {
        unit = unit.trim();
        if (!unit) {
            return Promise.reject('unit is empty!');
        }
        var body = {
            collection: 'authorizedUnit',
            value: {
                type: 'domain',
                unit: unit,
                created_timestamp: Date.now()
            }
        };
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).createData(body.collection, body.value);
    };
    UserProviderImpl.prototype.removeCodingbarDomainAccessUnitList = function (unit) {
        if (!unit) {
            return Promise.reject('unit is empty!');
        }
        var body = { collection: 'authorizedUnit', filter: { type: 'domain', unit: unit } };
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).removeData(body.collection, body.filter);
    };
    return UserProviderImpl;
}());
exports.UserProviderImpl = UserProviderImpl;
//# sourceMappingURL=UserProviderImpl.js.map